import { Box, styled, Typography } from "@mui/material";
import { FC } from "react";
import { PrimaryClassification } from "~/gen/api/governance";


const colors = {
  light: [ '#548044', '#757575', '#432D14', '#0013C3' ],
  dark:  [ '#90DD75', '#DBDBDB', '#825017', '#2C41FF' ],
}

interface ClassificationLabelProps {
  variant: PrimaryClassification,
  text: string,
}

const ClassificationLabelRoot = styled(Box)((
  //@ts-expect-error
  {theme, variant}
) => ({
  width: 96,
  height: 36,
  borderRadius: '12px',
  border: `1px solid ${colors[theme.palette.mode][variant]}`,

  '& > div': {
    display: 'flex',
    justifyContent: 'space-around',
    width: '100%',
    height: '50%',          
    position: 'relative',
    left: -1,
    top: -1,

    '&:first-of-type': {
      backgroundColor: colors[theme.palette.mode][variant],
      border: `1px solid ${colors[theme.palette.mode][variant]}`,
      borderTopLeftRadius: 12,
      borderTopRightRadius: 12,
    }
  },

  '& .p-text': { fontWeight: 700, color: theme.palette.background.paper },
  '& .s-text': { 
    fontStyle: 'italic', 
    fontWeight: 300, 
    color: colors[theme.palette.mode][variant],
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    paddingLeft: '2px',
    paddingRight: '2px',
  },
}))

const ClassificationLabel: FC<ClassificationLabelProps> = ({
  variant,
  text,
}) => {
  return (
    <ClassificationLabelRoot {...{variant}}>
      <Box>
        <Typography variant="caption" className="p-text">{PrimaryClassification[variant]}</Typography>
      </Box>
      <Box>
        <Typography variant="caption" className="s-text">{text}</Typography>
      </Box>
    </ClassificationLabelRoot>
  )
}

export default ClassificationLabel;
